const CALENDLY_URL = "https://calendly.com/hello-krystaldaniellecoaching/1hr";

export default function CallToAction() {
  return (
    <section id="book" className="relative bg-ink py-28 md:py-40 overflow-hidden">
      {/* Subtle warm tint overlay */}
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(ellipse at 30% 60%, #D9CEBC 0%, transparent 60%)" }} />

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">

        <p className="font-sans text-xs tracking-widest2 uppercase text-stone mb-8">
          Your Next Move
        </p>

        <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl font-light text-white leading-tight mb-8">
          Ready when<br />
          <em className="font-medium">you are.</em>
        </h2>

        <a
          href={CALENDLY_URL}
          target="_blank"
          rel="nofollow noreferrer"
          className="inline-block font-sans text-sm tracking-widest uppercase px-10 py-5 bg-white text-ink hover:bg-cream transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          Reserve Your Clarity Session
        </a>

        <p className="font-sans text-xs text-stone/60 mt-6 tracking-wide">
          Via Calendly &mdash; choose a time that works for you
        </p>

      </div>
    </section>
  );
}
